var OrderStatusEnum;
(function (OrderStatusEnum) {
    OrderStatusEnum["PreparingFood"] = "preparing-food";
    OrderStatusEnum["FoodReady"] = "food-prepared";
    OrderStatusEnum["Cancelled"] = "cancelled";
    OrderStatusEnum["Completed"] = "completed";
})(OrderStatusEnum || (OrderStatusEnum = {}));
var OrderSuccessText;
(function (OrderSuccessText) {
    OrderSuccessText["PreparingFood"] = "orderSuccess.preparingFood";
    OrderSuccessText["FoodReady"] = "orderSuccess.foodReady";
    OrderSuccessText["Cancelled"] = "orderSuccess.cancelled";
    OrderSuccessText["Completed"] = "orderSuccess.completed";
})(OrderSuccessText || (OrderSuccessText = {}));
var OrderStatusText;
(function (OrderStatusText) {
    OrderStatusText["PreparingFood"] = "orderSuccess.preparingFoodStatus";
    OrderStatusText["FoodReady"] = "orderSuccess.foodReadyStatus";
})(OrderStatusText || (OrderStatusText = {}));

export { OrderStatusEnum, OrderStatusText, OrderSuccessText };
//# sourceMappingURL=order_status.enum.js.map
